import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerComponent } from './customer/list/customer.component';
import { AddCustomerComponent } from './customer/add/add-customer.component';
import { CustomerDetailsComponent } from './customer/detail/customer-details.component';
import { PoListComponent } from './po/po-list/po-list.component';
import { PoDetailsComponent } from './po/po-details/po-details.component';
import { CreatePOComponent } from './po/create-po/create-po.component';
import { RecentPoComponent } from './po/recent-po/recent-po.component';
import { CreateInvoiceComponent } from './invoice/create-invoice/create-invoice.component';
import { InvoiceDetailsComponent } from './invoice/invoice-details/invoice-details.component';
import { InvoiceListComponent } from './invoice/invoice-list/invoice-list.component';
import { RecentPiComponent } from './invoice/recent-pi/recent-pi.component';
import { VendorsListComponent } from './vendor/vendors-list/vendors-list.component';
import { CreateVendorComponent } from './vendor/create-vendor/create-vendor.component';
import { TopVendorsComponent } from './vendor/top-vendors/top-vendors.component';
import { VendorDetailsComponent } from './vendor/vendor-details/vendor-details.component';
import { StateComponent } from './state/state.component';
import { CityComponent } from './city/city.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { CreateUserComponent } from './user/create-user/create-user.component';
import { UserRolesComponent } from './user-roles/user-roles.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PoApproverDashboardComponent } from './po-approver/po-approver-dashboard/po-approver-dashboard.component';
import { PoApproverDetailsComponent } from './po-approver/po-approver-details/po-approver-details.component';
import { ApprovedPoComponent } from './po-approver/approved-po/approved-po.component';
import { PendingPoComponent } from './po-approver/pending-po/pending-po.component';
import { RejectedPoComponent } from './po-approver/rejected-po/rejected-po.component';
import { FinanceTeamDashboardComponent } from './finance-team/finance-team-dashboard/finance-team-dashboard.component';
import { PaidInvoicesComponent } from './finance-team/paid-invoices/paid-invoices.component';
import { UnpaidInvoicesComponent } from './finance-team/unpaid-invoices/unpaid-invoices.component';
import { FinanceTeamPoDetailsComponent } from './finance-team/finance-team-po-details/finance-team-po-details.component';
import { DepartmentListComponent } from './department/department-list/department-list.component';
import { AddDepartmentComponent } from './department/add-department/add-department.component';
import { PaymenttermListComponent } from './paymentTerms/paymentterm-list/paymentterm-list.component';
import { AddPaymenttermComponent } from './paymentTerms/add-paymentterm/add-paymentterm.component';
import { QuotationListComponent } from './quotations/quotation-list/quotation-list.component';
import { QuotationDetailsComponent } from './quotations/quotation-details/quotation-details.component';
import { AddRequirementComponent } from './quotations/add-requirement/add-requirement.component';
import { BrandComponent } from './brand/brand.component';
import { CreateItemComponent } from './item/create-item/create-item.component';
import { ItemListComponent } from './item/item-list/item-list.component';
import { ItemDetailsComponent } from './item/item-details/item-details.component';
import { ItemCategoryComponent } from './item-category/item-category.component';
import { ItemUomComponent } from './item-uom/item-uom.component';
import { ReviewListComponent } from './po-reviewer/review-list/review-list.component';
import { ReviewDetailsComponent } from './po-reviewer/review-details/review-details.component';
import { PoReviewerDashboardComponent } from './po-reviewer/po-reviewer-dashboard/po-reviewer-dashboard.component';
// import { PomatrixComponent } from './po/Matrix-po/potracking.component';
// Newly added 
//WareHousse
import { CreateWarehouseComponent } from './warehouse/create-warehouse/create-warehouse.component';
import { WarehouseListComponent } from './warehouse/warehouse-list/warehouse-list.component';
import { WarehouseDetailsComponent } from './warehouse/warehouse-details/warehouse-details.component';

import { CreateEntityComponent } from './entity/create-entity/create-entity.component';
import { EntityListComponent } from './entity/entity-list/entity-list.component';
import { EntityDetailsComponent } from './entity/entity-details/entity-details.component';

import { CreateCostcenterComponent } from './costcenter/create-costcenter/create-costcenter.component';
import { CostcenterListComponent } from './costcenter/costcenter-list/costcenter-list.component';
import { CostcenterDetailsComponent } from './costcenter/costcenter-details/costcenter-details.component';

import { CreatePaymentComponent } from './payment/create-payment/create-payment.component';
import { PaymentListComponent } from './payment/payment-list/payment-list.component';
import { PaymentDetailsComponent } from './payment/payment-details/payment-details.component';
import { PotrackingComponent } from './po/potracking/potracking.component';


import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth.guard';
import { Role } from './model/Role';
const routes: Routes = [
  {
    path: 'customers',
    component: CustomerComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'customer/add',
    component: AddCustomerComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'customers/:id',
    component: CustomerDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'po-list',
    component: PoListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POCreator, Role.TeamMember] }
  },
  {
    path: 'create-po', //create-po/add for adding new po  
    component: CreatePOComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POCreator] }
  },
  {
    path: 'update-po/:po_id', //create-po/add for adding new po  
    component: CreatePOComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POCreator] }
  },
  {
    path: 'po-details/:poid',//po-details/:id for details page id wise
    component: PoDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'recent-purchase-orders',//po-details/:id for details page id wise
    component: RecentPoComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'invoice-list',
    component: InvoiceListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POCreator] }
  },
  {
    path: 'create-invoice', //create-po/add for adding new po  
    component: CreateInvoiceComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POCreator] }
  },
  {
    path: 'update-invoice/:invoiceId', //create-po/add for adding new po  
    component: CreateInvoiceComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POCreator] }
  },
  {
    path: 'invoice-details/:invoiceId',//po-details/:id for details page id wise
    component: InvoiceDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POCreator] }
  },
  {
    path: 'recent-paid-invoices',//po-details/:id for details page id wise
    component: RecentPiComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'vendors-list',
    component: VendorsListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'create-vendor', //create-po/add for adding new po  
    component: CreateVendorComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'update-vendor/:vendorId', //edit vendor 
    component: CreateVendorComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'vendor-details/:vendorId',//po-details/:id for details page id wise
    component: VendorDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'top-vendors',//po-details/:id for details page id wise
    component: TopVendorsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'state',//po-details/:id for details page id wise
    component: StateComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'city',//po-details/:id for details page id wise
    component: CityComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'user-list',//po-details/:id for details page id wise
    component: UserListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'create-user',//po-details/:id for details page id wise
    component: CreateUserComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'create-user/:userId',//po-details/:id for details page id wise
    component: CreateUserComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'user-roles',//po-details/:id for details page id wise
    component: UserRolesComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'po-approver-dashboard',//po-details/:id for details page id wise
    component: PoApproverDashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POApproval] }
  },
  {
    path: 'po-approver-details/:poid',//po-details/:id for details page id wise
    component: PoApproverDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POApproval] }
  },
  {
    path: 'approved-po',//po-details/:id for details page id wise
    component: ApprovedPoComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POApproval] }
  },
  {
    path: 'pending-po',//po-details/:id for details page id wise
    component: PendingPoComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POApproval] }
  },
  {
    path: 'po-approver-dashboard',//po-details/:id for details page id wise
    component: PoApproverDashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POApprovalLevel1] }
  },
  {
    path: 'po-approver-details/:poid',//po-details/:id for details page id wise
    component: PoApproverDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POApprovalLevel1] }
  },
  {
    path: 'approved-po',//po-details/:id for details page id wise
    component: ApprovedPoComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POApprovalLevel1] }
  },
  {
    path: 'pending-po',//po-details/:id for details page id wise
    component: PendingPoComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POApproval] }
  },

  {
    path: 'rejected-po',//po-details/:id for details page id wise
    component: RejectedPoComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  // { 
  //   path: 'Matrix-po',//po-details/:id for details page id wise
  // component: PomatrixComponent,
  // canActivate: [AuthGuard],
  // data: { roles: [Role.Admin,Role.POApprovalLevel1]}
  // },
  {
    path: 'finance-team-dashboard',//po-details/:id for details page id wise
    component: FinanceTeamDashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'finance-team-po-details/:invoiceid',//po-details/:id for details page id wise
    component: FinanceTeamPoDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'paid-invoices',//po-details/:id for details page id wise
    component: PaidInvoicesComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'unpaid-invoices',//po-details/:id for details page id wise
    component: UnpaidInvoicesComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'department-list',
    component: DepartmentListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'add-department',
    component: AddDepartmentComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'add-department/:deptid',
    component: AddDepartmentComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'paymentterm-list',
    component: PaymenttermListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'add-paymentterm',
    component: AddPaymenttermComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'add-paymentterm/:paymenttermid',
    component: AddPaymenttermComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'quotation-list',
    component: QuotationListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'quotation-details/:requirementid',//po-details/:id for details page id wise
    component: QuotationDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'add-requirement',
    component: AddRequirementComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'add-requirement/:requirementid',
    component: AddRequirementComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'brand',//po-details/:id for details page id wise
    component: BrandComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'items-list',
    component: ItemListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'create-item', //create-po/add for adding new po  
    component: CreateItemComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'update-item/:itemId', //edit vendor 
    component: CreateItemComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'item-details/:itemId',//po-details/:id for details page id wise
    component: ItemDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'item-category',//po-details/:id for details page id wise
    component: ItemCategoryComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'item-uom',//po-details/:id for details page id wise
    component: ItemUomComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'review-list',//review-list/:id for details page id wise
    component: ReviewListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.POreviewer] }
  },


  {
    path: 'review-details/:poid',//review-details/:id for details page id wise
    component: ReviewDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },

  {
    path: 'po-reviewer-dashboard',//review-details/:id for details page id wise
    component: PoReviewerDashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'warehouse-list',
    component: WarehouseListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'create-warehouse', //create-po/add for adding new po  
    component: CreateWarehouseComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'update-warehouse/:warehouseid', //edit vendor 
    component: CreateWarehouseComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'warehouse-details/:warehouseid',//po-details/:id for details page id wise
    component: WarehouseDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },

  {
    path: 'entity-list',
    component: EntityListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'create-entity', //create-po/add for adding new po  
    component: CreateEntityComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'update-entity/:entityid', //edit vendor 
    component: CreateEntityComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'entity-details/:entityid',//po-details/:id for details page id wise
    component: EntityDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },

  {
    path: 'payment-list',
    component: PaymentListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'create-payment', //create-po/add for adding new po  
    component: CreatePaymentComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'update-payment/:paymentid', //edit vendor 
    component: CreatePaymentComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'payment-details/:paymentid',//po-details/:id for details page id wise
    component: PaymentDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },

  {
    path: 'costcenter-list',
    component: CostcenterListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'create-costcenter', //create-po/add for adding new po  
    component: CreateCostcenterComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'update-costcenter/:costcenterid', //edit vendor 
    component: CreateCostcenterComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'costcenter-details/:costcenterid',//po-details/:id for details page id wise
    component: CostcenterDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin] }
  },
  {
    path: 'potracking',
    component: PotrackingComponent,
    canActivate: [AuthGuard],
    data: {}
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
